//import logo from './logo.svg';
import React , { useState } from 'react'
import './App.css';

import './styles.css'

import LoadExcel from './Components/LoadExcel/LoadExcel';

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Configurador from './Components/Configurador/Configurador';
import ConfiguradorForm2 from './Components/Configurador/ConfiguradorForm2';
import ConfiguradorForm3 from './Components/Configurador/ConfiguradorForm3';
import ConfigCuentasDetail from './Components/Configurador/ConfigCuentasDetail';
import TipoCuenta from './Components/TipoCuenta/TipoCuenta';

import CfdiLoader from './Components/Cfdi/CfdiLoader';
import Facturacion from './Facturacion/Facturacion';
import Productos from './Facturacion/Productos';
import ViewXml from './Facturacion/ViewXml';
import Pedidos from './Components/Pedidos/Pedidos';
import Divisas from './Components/Divisas/Divisas';
import Divisas2 from './Components/Divisas/Divisas2';
import Promos from './Components/LoadExcel/Promos/Promos';
import Translate from './Components/LoadExcel/Promos/Translate';
import Login from './Components/Login/Login';
import Login2 from './Components/Login/Login2';
import SignUp from './Components/Login/SignUp';
import SignUp2 from './Components/Login/SignUp2';



import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';



import { PrimeReactProvider } from 'primereact/api';


function App() {
  const [isLogged,setIsLogged] = useState( false )

  const value = {
    cssTransition: false,
  
};


  return (
    <PrimeReactProvider>
    <BrowserRouter>
      
        {/*
          
          <div className="w-100" >
          <LoadExcel/> 
          <Login/>
          
          </div> */}
          


      


      <Routes>
          <Route exact path="/" element={<Login2  />} />
          <Route path="/login" element={<Login  />} />
          <Route path="/login2" element={<Login2  />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signup2" element={<SignUp2 />} />
          <Route path="/configurador" element={<ConfiguradorForm3 />} />
          <Route path="/configdetail" element={<ConfigCuentasDetail />} />
          <Route path="/tipocuenta" element={<TipoCuenta />} />
          <Route path="/cfdiloader" element={<CfdiLoader />} />
          <Route path="/facturacion" element={<Facturacion/>} />
          <Route path="/productos" element={<Productos/>} />
          <Route path="/pedidos" element={<Pedidos/>} />
          <Route path="/divisas" element={<Divisas/>} />
          <Route path="/divisas2" element={<Divisas2/>} />
          <Route path="/promos" element={<Promos></Promos>}></Route>
          <Route path="/translate" element={<Translate/>}></Route>

          <Route path="/loadexcel" element={<LoadExcel/>}></Route>

          <Route path="/viewxml" element={<ViewXml />} />
          <Route path="/login" element={<Login />} />
 
      </Routes>

    </BrowserRouter>


    </PrimeReactProvider>




  );
}

export default App;


    // <BrowserRouter>
    //   <Header hideNav={hideNav} setLogin={theLogin} 
    //     isLogout={theTimeOut} setLogOut={setLogOut}></Header>
    //   <Routes>
        
        
          
    //     <Route path="/login" 
    //       element={<Login addMember={onAddMember} extSet={extExists} askExtension={onAskExtension}
    //         hide={(val)=> setHideNav( val )} 
    //       salir={onSalir}/>} />
    //     <Route path="/agentes" element={<Agentes hide={(val)=> setHideNav( val )} />} />
    //     <Route path="/admindash"  element={<AdminDash adminChangeCampain={onAdminChangeCampain}
    //       setCampain={setCampain} setAgents={agents}/>} />
    //     <Route path="/adminagentdash" element={<AdminAgentDash 
    //       logouttime={onTimeout} stateChange={onStateChange}/>}  />
    //     <Route path="/uploadfile" element={<UpLoadFile/>} />
    //     <Route path="/uploadcalifica" element={<UpLoadCalifica/>} />

        
    //   </Routes>
    // </BrowserRouter>



